module.exports = __webpack_public_path__ + "static/media/icon-facebook.04a5ba3b.svg";